import React from 'react'
import { Grid } from '@material-ui/core'
import SpacingContainer from '../../common/Containers/Base/SpacingContainer'
import Paper from '../../common/Containers/Paper'
import Typography from '../../common/Typography'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo)
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null })
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback
      }

      return (
        <SpacingContainer py={10} px={7}>
          <Paper component={SpacingContainer} px={5} py={10}>
            <Grid
              container
              alignItems="center"
              justifyContent="center"
              alignContent="center"
              direction="column"
            >
              <Typography
                color="hint"
                gutter="bottom2"
                align="center"
                component="div"
              >
                <ErrorOutlineIcon style={{ fontSize: 64 }} />
              </Typography>

              <Typography
                variant="h1Medium"
                weight="300"
                gutter="title"
                component="h5"
                fontFamily="lexend"
                align="center"
              >
                Something went wrong
              </Typography>

              <Typography
                variant="body1"
                color="hint"
                align="center"
                gutter="bottom2"
              >
                An unexpected error occurred. Please try again.
              </Typography>

              <button
                onClick={this.handleRetry}
                style={{
                  padding: '8px 24px',
                  fontSize: '14px',
                  fontFamily: 'Lexend, sans-serif',
                  backgroundColor: '#f32445',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                }}
              >
                Try again
              </button>
            </Grid>
          </Paper>
        </SpacingContainer>
      )
    }

    return this.props.children
  }
}
